// ─────────────────────────────────────────────────────────────────────────────
// icons.js — inline SVGs used across the Settings page. Stroke is currentColor
// so each call site controls the colour via CSS.
// ─────────────────────────────────────────────────────────────────────────────
const tab = { width: 17, height: 17, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7 };

export const IcoCompany = () => (
  <svg {...tab}>
    <path d="M3 21h18"/>
    <path d="M5 21V5a2 2 0 012-2h6a2 2 0 012 2v16"/>
    <path d="M15 21V11h3a1 1 0 011 1v9"/>
    <path d="M9 7h2M9 11h2M9 15h2"/>
  </svg>
);

export const IcoShield = () => (
  <svg {...tab}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

export const IcoLock = () => (
  <svg {...tab}>
    <rect x="3.5" y="10.5" width="17" height="11" rx="2"/>
    <path d="M7.5 10.5V7a4.5 4.5 0 019 0v3.5"/>
  </svg>
);

export const IcoLink = () => (
  <svg {...tab}>
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
  </svg>
);

export const IcoBell = () => (
  <svg {...tab}>
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 01-3.46 0"/>
  </svg>
);

export const IcoPlug = () => (
  <svg {...tab} width="18" height="18">
    <path d="M12 22v-5"/>
    <path d="M9 7V2M15 7V2"/>
    <path d="M6 7h12v4a6 6 0 01-12 0z"/>
  </svg>
);

export const IcoGear = () => (
  <svg {...tab} width="20" height="20" strokeWidth="1.6">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
  </svg>
);

export const IcoSave = () => (
  <svg {...tab} width="15" height="15" strokeWidth="2">
    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/>
    <polyline points="17 21 17 13 7 13 7 21"/>
    <polyline points="7 3 7 8 15 8"/>
  </svg>
);
